import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import {
  AppliedFilterType,
  FilterType,
  TextType,
  WeekType,
  DateRangeType,
  NumberType,
} from '@app/core/interfaces/filter.interface';
import { PresetOptionEnum } from '@app/core/constants/date_presets.enum';
import { DatePipe } from '@angular/common';
import { HumanizePipe } from '@app/core/pipes/humanize.pipe';

@Component({
  selector: 'ag1-pill',
  templateUrl: './ag1-pill.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DatePipe, HumanizePipe],
})
export class Ag1PillComponent {
  @Input() filter: FilterType;
  @Input() appliedFilters: AppliedFilterType[];

  constructor() {}

  get startDateRange(): string | null {
    if (!this.appliedFilters[this.filter.name]?.startDateRange) {
      return null;
    }

    const utcStartDate: Date = new Date(
      (this.appliedFilters[this.filter.name] as DateRangeType).startDateRange,
    );

    // ensure that the start date is converted to local time
    // for better user experience when selecting dates
    const startDate: Date = new Date(
      utcStartDate.getUTCFullYear(),
      utcStartDate.getUTCMonth(),
      utcStartDate.getUTCDate(),
      utcStartDate.getUTCHours(),
      utcStartDate.getUTCMinutes(),
      utcStartDate.getUTCSeconds(),
      utcStartDate.getUTCMilliseconds(),
    );

    return String(startDate);
  }

  get endDateRange(): string | null {
    if (!this.appliedFilters[this.filter.name]?.endDateRange) {
      return null;
    }

    const utcEndDate: Date = new Date(
      (this.appliedFilters[this.filter.name] as DateRangeType).endDateRange,
    );

    // ensure that the end date is converted to local time
    // for better user experience when selecting dates
    const endDate: Date = new Date(
      utcEndDate.getUTCFullYear(),
      utcEndDate.getUTCMonth(),
      utcEndDate.getUTCDate(),
      utcEndDate.getUTCHours(),
      utcEndDate.getUTCMinutes(),
      utcEndDate.getUTCSeconds(),
      utcEndDate.getUTCMilliseconds(),
    );

    return String(endDate);
  }

  get dateRangePresetOption(): PresetOptionEnum | null {
    if (!this.appliedFilters[this.filter.name]?.presetOption) {
      return null;
    }

    return (this.appliedFilters[this.filter.name] as DateRangeType)
      .presetOption;
  }

  get startWeek(): string {
    return (this.appliedFilters[this.filter.name] as WeekType).startWeek;
  }

  get endWeek(): string {
    return (this.appliedFilters[this.filter.name] as WeekType).endWeek;
  }

  get text(): string {
    return (this.appliedFilters[this.filter.name] as TextType).text;
  }

  get number(): number {
    return (this.appliedFilters[this.filter.name] as NumberType).number;
  }

  appliedFilterTrackBy(index: number, item: any): number | string {
    if (item?.id) {
      return item.id;
    }

    if (item?.value) {
      return item.value;
    }

    if (item?.label) {
      return item.label;
    }

    return index;
  }
}
